type FavoritesCacheValue = {
  productIds: string[]
  fetchedAt: number
}

const STORAGE_KEY = "favorites_cache_v1"

export function readFavoritesCache(): FavoritesCacheValue | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as FavoritesCacheValue
    if (!Array.isArray(parsed?.productIds) || typeof parsed?.fetchedAt !== "number") return null
    return parsed
  } catch {
    return null
  }
}

export function writeFavoritesCache(productIds: string[]): void {
  try {
    const value: FavoritesCacheValue = {
      productIds,
      fetchedAt: Date.now(),
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // ignore
  }
}

export function isFavoritesCacheFresh(cache: FavoritesCacheValue | null, ttlMs: number): boolean {
  if (!cache) return false
  return Date.now() - cache.fetchedAt <= ttlMs
}

export function getFavoritesCountFromCache(): number {
  return readFavoritesCache()?.productIds?.length || 0
}
